'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/react/react.js
// module id = 3
// module chunks = 0